module.exports = __webpack_public_path__ + "static/media/volunteer-logo.9725d593.png";